import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

// Visually-hidden skip link, visible on focus, that jumps to #main-content. Must be the
// first focusable element in Layout so keyboard users can bypass the header navigation.
export default function SkipToMain() {
  const { t } = useLanguage();
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:left-2 focus:top-2 focus:z-[100] focus:rounded-md focus:bg-signal-blue focus:px-4 focus:py-2 focus:text-white focus:shadow-lg"
    >
      {t('experience.a11y.skip_to_main', 'Skip to main content')}
    </a>
  );
}
